import { render, staticRenderFns } from "./CheckboxRenderer.vue?vue&type=template&id=18c993a2&"
import script from "./CheckboxRenderer.vue?vue&type=script&lang=js&"
export * from "./CheckboxRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports